import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_mobile-appsflyer_onelink_failed-action_unknown';

/**
 * Failed to generate AppsFlyer link
 */
export function trackRetailerMobileAppsflyerOnelinkFailed(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
